import React, { useState, useEffect } from "react";
import {
  PDFViewer,
  Document,
  View,
  Page,
  Text,
  Image,
  StyleSheet,
  Svg,
  Path,
} from "@react-pdf/renderer";
import Portada from "../../../images/PortadaTrabajadroesProveedor.png";
import Logo from "../../../images/LogoLAE.png";
import { withRouter } from "../../../providers/withRouter";
import { getTrabajadores } from "../../../services";
import CircularProgress from "@mui/material/CircularProgress";
import PDFHandler from "../../../components/pdfs/PDFHandler";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const InformeTrabajadores = (props) => {
  const { t } = useTranslation('pdfs');
  const styles = StyleSheet.create({
    docTitle: {
      position: 'absolute',
      left: 70,
      right: 70,
      bottom: '70px',
      textAlign: 'center',
      fontSize: '16px',
      color: '#B50655' || '#023867',
      fontFamily: 'Roboto',
      fontWeight: 700,
      textTransform: 'uppercase'
    },
    pagina: {
      // marginTop: "50px",
      padding: "0px 50px",
      fontSize: "8px",
    },
    pageBreak: {
      pageBreak: 'always',
      marginBottom: 100,
      borderBottomWidth: 1,
    },
    pdfFooter: {
      marginTop: "70px",
    },
    table: {
      display: "table",
      width: "auto",
      marginBottom: 30,

    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
    },
    tableColHeader: {
      width: "auto",
      borderStyle: "solid",
      borderWidth: 0,
      backgroundColor: "#375491",
      color: "#ffffff",
    },
    tableCell: {
      margin: "auto",
      marginTop: 5,
      marginBottom: 5,
      fontSize: 8,
    },
    p: {
      lineHeight: "1.5",
      textAlign: "justify",
      paddingBottom: 20,
    },
    containerHeader: {
      flexDirection: "row",
      borderStyle: "solid",
      borderWidth: 1,
      borderBottomWidth: 0,
      topBorderWidth: 0,
      alignItems: "center",
      height: 27,
      textAlign: "center",
      fontWeight: "ultrabold",
      flexGrow: 1,
      fontSize: "6px",
    },
    nifHeader: {
      width: "20%",
      borderRightColor: "#000",
      borderRightWidth: 1,
      borderTopWidth: 1,
      paddingVertical: 7.5,
      height: 27,
      paddingTop: 11,
      backgroundColor: '#c31e64',
      color: '#ffffff',
    },
    nombreHeader: {
      width: "20%",
      borderRightColor: "#000",
      borderRightWidth: 1,
      borderTopWidth: 1,
      paddingVertical: 7.5,
      height: 27,
      paddingTop: 11,
      backgroundColor: '#c31e64',
      color: '#ffffff',
    },
    apellidosHeader: {
      width: "21%",
      borderRightColor: "#000",
      borderRightWidth: 1,
      borderTopWidth: 1,
      paddingVertical: 7.5,
      height: 27,
      paddingTop: 11,
      backgroundColor: '#c31e64',
      color: '#ffffff',
    },
    formacionHeader: {
      width: "13%",
      borderRightColor: "#000",
      borderRightWidth: 1,
      borderTopWidth: 1,
      paddingVertical: 7.5,
      height: 27,
      paddingTop: 11,
      backgroundColor: '#c31e64',
      color: '#ffffff',
    },
    epiHeader: {
      width: "13%",
      borderTopWidth: 1,
      paddingVertical: 7.5,
      height: 27,
      paddingTop: 11,
      backgroundColor: '#c31e64',
      color: '#ffffff',
    },
    aptitudHeader: {
      width: "13%",
      borderLeftColor: "#000",
      borderLeftWidth: 1,
      borderTopWidth: 1,
      paddingVertical: 7.5,
      height: 27,
      paddingTop: 11,
      backgroundColor: '#c31e64',
      color: '#ffffff',
    },
    rowCell: {
      flexDirection: "row",
      borderWidth: 1,
      borderBottomWidth: 0,
      alignItems: "center",
      textAlign: "center",
      fontStyle: "bold",
      flexGrow: 1,
      fontSize: "6px",
    },
    fincaCell: {
      width: "40%",
      textAlign: "left",
      borderRightColor: "#000",
      borderRightWidth: 1,
      paddingVertical: 7.5,
      height: 30,
      paddingLeft: 2,
      paddingTop: 12,
    },
    nifCell: {
      width: "20%",
      textAlign: "center",
      borderRightColor: "#000",
      borderRightWidth: 1,
      paddingVertical: 7.5,
      height: 30,
      paddingTop: 12,
    },
    nombreCell: {
      width: "20%",
      textAlign: "center",
      borderRightColor: "#000",
      borderRightWidth: 1,
      paddingVertical: 7.5,
      height: 30,
    },
    apellidosCell: {
      width: "21%",
      textAlign: "center",
      borderRightColor: "#000",
      borderRightWidth: 1,
      paddingVertical: 7.5,
      height: 30,
    },
    formacionCell: {
      width: "13%",
      textAlign: "center",
      borderRightColor: "#000",
      borderRightWidth: 1,
      paddingVertical: 7.5,
      height: 30,
    },
    epiCell: {
      width: "13%",
      textAlign: "center",
      borderRightColor: "#000",
      borderRightWidth: 1,
      paddingVertical: 7.5,
      height: 30,
    },
    aptitudCell: {
      width: "13%",
      textAlign: "center",
      paddingVertical: 7.5,
      height: 30,
    },
    svg: {
      height: "15pt",
      width: "15pt",
      margin: "auto",
    },
  });

  const location = useLocation();
  const [trabajadores, setTrabajadores] = useState({});
  const [isLoading, setIsloading] = useState(true);

  const Cross = (
    <Svg fill="#FF5252" viewBox="0 0 512 512" style={styles.svg}>
      <Path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm94.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0" />
    </Svg>
  );
  const Tick = (
    <Svg fill="#7bc977" viewBox="0 0 512 512" style={styles.svg}>
      <Path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm129.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0" />
    </Svg>
  );
  const Indeterminate = (
    <Svg fill="#FFBB33" viewBox="0 0 512 512" style={styles.svg}>
      <Path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm94.273438 320.105469c8.339843 8.34375 8.339843 21.824219 0 30.167969-4.160157 4.160156-9.621094 6.25-15.085938 6.25-5.460938 0-10.921875-2.089844-15.082031-6.25l-64.105469-64.109376-64.105469 64.109376c-4.160156 4.160156-9.621093 6.25-15.082031 6.25-5.464844 0-10.925781-2.089844-15.085938-6.25-8.339843-8.34375-8.339843-21.824219 0-30.167969l64.109376-64.105469-64.109376-64.105469c-8.339843-8.34375-8.339843-21.824219 0-30.167969 8.34375-8.339843 21.824219-8.339843 30.167969 0l64.105469 64.109376 64.105469-64.109376c8.34375-8.339843 21.824219-8.339843 30.167969 0 8.339843 8.34375 8.339843 21.824219 0 30.167969l-64.109376 64.105469zm0 0" />
    </Svg>
  );
  useEffect(() => {
    fetchData()
  }, []);

  const token = localStorage.getItem('token');

  if(!token){
    return <Navigate replace to="/login" state={{from: location}} />
  }

  const fetchData = async () => {
    try {
      let trabajadores = await getTrabajadores(props.params.nif);
      setIsloading(false);
      setTrabajadores(trabajadores);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {isLoading ? (
        <CircularProgress
          style={{
            color: "#92004D",
            position: "absolute",
            top: "50%",
            left: "50%",
          }}
        />
      ) : (
        <PDFHandler style={{ width: "100%", height: "100vh" }}>
          <Document size="A4" margin="2cm">
            <Page style={styles.body}>
              <View>
                <Image
                  id="portada"
                  className="portada"
                  style={{ width: "100%", height: "100vh" }}
                  src={Portada}
                />
                <Text style={styles.docTitle}>
                  {trabajadores?.razonSocial}
                </Text>
              </View>

              <View>
                <View style={{ marginTop: 0, paddingBottom: 20, marginHorizontal: '2cm' }} fixed>
                  <View >
                    <Image src={Logo} style={{ marginTop: 20, width: '20%' }} />
                  </View>
                </View>
                {/* <View style={styles.pdfHeader} fixed>
                  <Image src={Encabezado} alt="encabezado" />
                </View> */}
                <View style={styles.pagina}>
                  <View style={styles.table}>
                    {trabajadores.length === 0 ? (
                      <></>
                    ) : (
                      <>
                        {/* Tabla de Trabajadores por Cuenta Ajena */}
                        {trabajadores.filter(t => !t.autonomo).length > 0 && (
                          <View style={styles.pageBreak}>
                            <Text style={{ fontSize: 10, fontWeight: 'bold', marginBottom: 10, color: '#c31e64' }}>
                              {t('workerReport.employeeWorkers')}
                            </Text>
                            <View style={styles.containerHeader}>
                              <Text style={styles.nifHeader}>{t('workerReport.nif')}</Text>
                              <Text style={styles.nombreHeader}>{t('workerReport.name')}</Text>
                              <Text style={styles.apellidosHeader}>{t('workerReport.lastName')}</Text>
                              <Text style={styles.formacionHeader}>{t('workerReport.training')}</Text>
                              <Text style={styles.epiHeader}>{t('workerReport.epi')}</Text>
                              <Text style={styles.aptitudHeader}>{t('workerReport.fitness')}</Text>
                            </View>
                            {trabajadores.filter(t => !t.autonomo).map((trabajador, i) => {
                              return (
                                <View key={i}>
                                  <View style={styles.rowCell}>
                                    <Text style={styles.nifCell}>{trabajador.nif}</Text>
                                    <Text style={styles.nombreCell}>{trabajador.nombre}</Text>
                                    <Text style={styles.apellidosCell}>{trabajador.apellidos}</Text>

                                    <View style={styles.formacionCell}>
                                      {(() => {
                                        const doc = trabajador.documentos?.find(d => d.trabajador_typedoc?.nombre === 'formacion');
                                        if (!doc?.ruta || (new Date(doc?.fecha_caducar) < new Date())) return Cross;
                                        if (doc.validado === false) return Indeterminate;
                                        return Tick;
                                      })()}
                                    </View>
                                    <View style={styles.epiCell}>
                                      {(() => {
                                        const doc = trabajador.documentos?.find(d => d.trabajador_typedoc?.nombre === 'EPIS');
                                        if (doc?.noProcede === true) return <Text>{t('workerReport.notApplicable')}</Text>;
                                        if (!doc?.ruta || (new Date(doc?.fecha_caducar) < new Date())) return Cross;
                                        if (doc.validado === false) return Indeterminate;
                                        return Tick;
                                      })()}
                                    </View>
                                    <View style={styles.aptitudCell}>
                                      {(() => {
                                        const doc = trabajador.documentos?.find(d => d.trabajador_typedoc?.nombre === 'aptitud_medica');
                                        if (doc?.baja === true) return <Text>{t('workerReport.sickLeave')}</Text>;
                                        if (!doc?.ruta || (new Date(doc?.fecha_caducar) < new Date())) return Cross;
                                        if (doc.validado === false) return Indeterminate;
                                        return Tick;
                                      })()}
                                    </View>
                                  </View>
                                </View>
                              );
                            })}
                          </View>
                        )}

                        {/* Tabla de Trabajadores Autónomos */}
                        {trabajadores.filter(t => t.autonomo).length > 0 && (
                          <View style={styles.pageBreak}>
                            <Text style={{ fontSize: 10, fontWeight: 'bold', marginBottom: 10, color: '#c31e64' }}>
                              {t('workerReport.selfEmployedWorkers')}
                            </Text>
                            <View style={styles.containerHeader}>
                              <Text style={styles.nifHeader}>{t('workerReport.nif')}</Text>
                              <Text style={styles.nombreHeader}>{t('workerReport.name')}</Text>
                              <Text style={styles.apellidosHeader}>{t('workerReport.lastName')}</Text>
                              <Text style={styles.formacionHeader}>{t('workerReport.selfEmployedReceipt')}</Text>
                              <Text style={styles.epiHeader}>{t('workerReport.prlTraining')}</Text>
                              <Text style={styles.aptitudHeader}>{t('workerReport.prlDocumentation')}</Text>
                            </View>
                            {trabajadores.filter(t => t.autonomo).map((trabajador, i) => {
                              return (
                                <View key={i}>
                                  <View style={styles.rowCell}>
                                    <Text style={styles.nifCell}>{trabajador.nif}</Text>
                                    <Text style={styles.nombreCell}>{trabajador.nombre}</Text>
                                    <Text style={styles.apellidosCell}>{trabajador.apellidos}</Text>

                                    <View style={styles.formacionCell}>
                                      {(() => {
                                        const doc = trabajador.documentos?.find(d => d.trabajador_typedoc?.nombre === 'recibo_autonomos');
                                        if (!doc?.ruta || (new Date(doc?.fecha_caducar) < new Date())) return Cross;
                                        if (doc.validado === false) return Indeterminate;
                                        return Tick;
                                      })()}
                                    </View>
                                    <View style={styles.epiCell}>
                                      {(() => {
                                        const doc = trabajador.documentos?.find(d => d.trabajador_typedoc?.nombre === 'formacion_prl');
                                        if (doc?.noProcede === true) return <Text>{t('workerReport.notApplicable')}</Text>;
                                        if (!doc?.ruta || (new Date(doc?.fecha_caducar) < new Date())) return Cross;
                                        if (doc.validado === false) return Indeterminate;
                                        return Tick;
                                      })()}
                                    </View>
                                    <View style={styles.aptitudCell}>
                                      {(() => {
                                        const doc = trabajador.documentos?.find(d => d.trabajador_typedoc?.nombre === 'documentacion_prl');
                                        if (doc?.noProcede === true) return <Text>{t('workerReport.notApplicable')}</Text>;
                                        if (!doc?.ruta || (new Date(doc?.fecha_caducar) < new Date())) return Cross;
                                        if (doc.validado === false) return Indeterminate;
                                        return Tick;
                                      })()}
                                    </View>
                                  </View>
                                </View>
                              );
                            })}
                          </View>
                        )}
                      </>
                    )}
                  </View>
                </View>
                <View style={styles.pdfFooter} fixed></View>
              </View>
            </Page>
          </Document>
        </PDFHandler>
      )}
    </>
  );
};

export default withRouter(InformeTrabajadores);
